module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABCElEQVR4AWKgJnh8U1kBiAHtmuEJAyEMRjvKjXAjOMKNkFHc4EZyFEdwhDQHBo5SaC1XL/lI4f0s3EONMUkScqe8kDtJWB6WfvJBq7ALVeBBav/veqcAffz4cSlyKjBfSPd/EXgSRViultiEJvBkmrBduZX4ZghBQiEECYV+ORNslG0kOjXDIu2raKYh1jjF47kYPy96YzuhIqyGQt5XQ6nvUnF2ynoW2R2L7N63lVLPFyA7ZzlEEoBIOkQygEiGEikAIiVE/kSIRNQyRoa5EGFSFIikESaNh3lY4T11kYoPAOUggAIdQMkUoIiN1FbAb/RMkIk+IkV72vDAQIxwzB+qiTEngMGzJ0dZCo8eV4VZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/Yellow-Moderate.png
// module id = 993
// module chunks = 1